import {
  AdAccountPlatform,
  AdAccountPlatformLabels,
  AdAccountResource,
} from "@arrowsup/platform-dtos";
import { AutocompleteInput, ReferenceInput, required } from "react-admin";
import { nameWithStatus } from "../connected-accounts/connected-account-fields";
import { adAccountLabel } from "./ad-platform-fields";

const optionText = (a: AdAccountResource) =>
  nameWithStatus(adAccountLabel(a), a.status);

/** Picks the `platform` ad account a stream reads from or sends to. */
export const AdAccountInput: React.FC<{ platform: AdAccountPlatform }> = ({
  platform,
}) => (
  <ReferenceInput
    source="adAccount.id"
    reference="ad-account"
    filter={{ platform }}
    sort={{ field: "name", order: "ASC" }}
  >
    <AutocompleteInput
      label={`${AdAccountPlatformLabels[platform]} Ad Account`}
      optionText={optionText}
      filterToQuery={(q: string) => ({ q })}
      helperText="Search by name or ID. Add one under Ad Accounts first."
      validate={required()}
      fullWidth
    />
  </ReferenceInput>
);
